import { useEffect } from "react";

// Adds <meta name="robots" content={content}> while the calling page is mounted.
// No-op when content is empty (production leaves the env var unset).
export default function useRobotsMeta(content) {
  useEffect(() => {
    if (!content) return undefined;
    const meta = document.createElement("meta");
    meta.name = "robots";
    meta.content = content;
    document.head.appendChild(meta);
    return () => meta.remove();
  }, [content]);
}
